/* src/pages/Donation/index.jsx */

import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./index.scss";

// Imports from your project
import backgroundMoonImage from "../../assets/images/moon-background.png";
import backgroundDuskImage from "../../assets/images/dusk-sky.png";
import masjid from "../../assets/images/masjid.jpeg";
import CustomQuote from "../../components/CustomQuote";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { backgroundVariants, pageVariants } from "../../assets/framer/styles";
import ShootingStars from "../../components/ShootingStars";
import FloatingClouds from "../../components/FloatingClouds";
import BirdAnimation from "../../components/BirdAnimation";
import ReverseFloatingClouds from "../../components/ReverseFloatingClouds";

// i18n
import { useTranslation } from "react-i18next";
import AutoAjr from "../../components/AutoAjr";

// Stripe setup
const stripeKey = window._ENV_?.REACT_APP_STRIPE_PUBLISHABLE_KEY || window._ENV_.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = loadStripe(stripeKey, {
  locale: "en-CA"
});

const Donation = () => {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const template = searchParams.get("template");
  const stage = parseInt(searchParams.get("stage") || "1", 10);
  const previousStage = useRef(stage);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (previousStage.current !== stage) {
      previousStage.current = stage;
    }
  }, [stage]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // Direction for framer motion page transitions
  const direction = stage < previousStage.current ? -1 : 1;

  // Determine background and quotes
  let backgroundImage;
  let quote;
  let reference;

  if (template === "Rajab") {
    backgroundImage = backgroundDuskImage;
    quote = t("rajabQuote");
    reference = t("rajabReference");
  } else if (template === "Fridays") {
    backgroundImage = masjid;
    quote = t("fridayQuote");
    reference = t("fridayReference");
  } else {
    backgroundImage = backgroundMoonImage;
    quote = t("ramadanQuote");
    reference = t("ramadanReference");
  }

  return (
    <div className="donatation-container">


      <div
        className="right-section"
        style={
          windowWidth <= 950
            ? { backgroundImage: `url(${backgroundImage})` }
            : {}
        }
      >
        {windowWidth <= 950 &&
          (template === "Hijri" ||
            template === "Lunar" ||
            template === "Hijri10" ||
            template === "Lunar10") && (
            <>
              <ShootingStars />
              <FloatingClouds />
            </>
          )}

        <div className="step-content-container">
          <AnimatePresence custom={direction} mode="wait">
            <motion.div
              key={stage}
              className="step-content"
         
              initial="enter"
              animate="center"
              exit="exit"
              custom={direction}
            >
              <Elements stripe={stripePromise}><AutoAjr /></Elements>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default Donation;
